import { CustomerInfo, Purchases } from '@revenuecat/purchases-js';
import { Env } from './ApiManager';
import { getDefaultEnv } from './index';

const sandboxApiKey = 'rcb_sb_hkowzrbWboDcgUiRqeVYSOMcM';
const prodApiKey = 'rcb_GooiAHKYFKydBwRymtDoqSyYtTRB';

export abstract class RCPurchaseManager {
  private static instance: Purchases;
  static env: Env | null = getDefaultEnv();

  static get apiKey() {
    switch (RCPurchaseManager.env) {
      case Env.Prod:
      case Env.PreProd:
        return prodApiKey;
      default:
        return sandboxApiKey;
    }
  }

  static getInstance(userId: string): Purchases {
    if (!RCPurchaseManager.instance) {
      RCPurchaseManager.instance = Purchases.configure(
        RCPurchaseManager.apiKey,
        userId
      );
    } else {
      RCPurchaseManager.instance.changeUser(userId);
    }
    return RCPurchaseManager.instance;
  }

  static async getCustomerInfo(): Promise<CustomerInfo | null> {
    try {
      const customerInfo = await RCPurchaseManager.instance.getCustomerInfo();
      return customerInfo;
    } catch (error) {
      console.error('Error fetching customer info:', error);
      return null;
    }
  }
}
